export default {
      id: "Icon--audio-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--audio",
      toString: function () {
        return this.url;
      }
    }